export const getTimestamp = (minuteResolution = 0) => {
  const now = new Date();
  const hours = now.getHours();
  const minutes =
    minuteResolution === 0
      ? now.getMinutes()
      : Math.floor(now.getMinutes() / minuteResolution) * minuteResolution;

  return `${hours % 12 || 12}:${minutes.toString().padStart(2, '0')} ${hours < 12 ? 'AM' : 'PM'}`;
};

/**
 * Builds a list of CSS selectors to determine if an element inside the content area should be clickable without
 * relocating the user to the detail page.
 */
export const clickableContentSelectors = [
  'a',
  'button',
  'input',
  '[data-interactive="true"]',
  '[data-is-modal="true"]',
]
  .map((selector) => `${selector}, ${selector} *`)
  .join(', ');
